import { useEffect, useRef } from 'react';

import { useAppDispatch } from '../../../hooks/redux/useApp';
import { HEARTBEAT_INTERVAL_MS } from '../models/lock';
import {
  acquireLockThunk,
  heartbeatLockThunk,
} from '../store/contentModerationThunks';

export interface UseReviewLockHeartbeatOptions {
  intervalMs?: number;
}

export function useReviewLockHeartbeat(
  eventId: number | null,
  isAcquired: boolean,
  options: UseReviewLockHeartbeatOptions = {},
): void {
  const dispatch = useAppDispatch();
  const intervalMs = options.intervalMs ?? HEARTBEAT_INTERVAL_MS;
  const reAcquiredRef = useRef(false);

  useEffect(() => {
    reAcquiredRef.current = false;
  }, [eventId, isAcquired]);

  useEffect(() => {
    if (!isAcquired || eventId == null || intervalMs <= 0) return undefined;

    const tick = async () => {
      const result = await heartbeatLockThunk(eventId)(dispatch);
      if (!result.ok && result.code === 'reviewLock.notFound' && !reAcquiredRef.current) {
        reAcquiredRef.current = true;
        await acquireLockThunk(eventId)(dispatch);
      }
    };

    const intervalId = window.setInterval(tick, intervalMs);
    return () => {
      window.clearInterval(intervalId);
    };
  }, [eventId, isAcquired, intervalMs, dispatch]);
}
